import { Typography } from '@mui/material';
import React from 'react';

interface ListHeaderProps {
  children?: React.ReactNode;
  className?: any;
}

export const ListHeader = ({
  className,
  children,
  ...rest
}: ListHeaderProps) => {
  return (
    <Typography className={className} m={0} variant='h3' {...rest}>
      {children}
    </Typography>
  );
};
